export default {
    getCurrentFDID(state) {
        return state.currentFD ? state.currentFD.id : null;
    },
    getCurrentFD(state) {
        return state.currentFD;
    },
    getFDs(state) {
        return state.fds;
    },
    getPastFDs(state) {
        return state.pastFDs;
    },
    getLiveFD: (state) => state.liveFD,
    hasMorePastFDs: (state) => state.hasMorePastFDs,
    getFDError: (state) => state.fdError,
}